/**
 * The construction categories the site knows how to present.
 *
 * Categories themselves are free-text `category` documents in Sanity, so the
 * project listing pages (`/projekti/<slug>`) are generated from the CMS in
 * `gatsby-node.js`. This list is the single source of truth for the frontend
 * pieces that need to *know* the standard categories ahead of time — the footer
 * navigation, the project filters and the `ConstructionType` union. The `slug`
 * must match a category `name` (lower-cased) in the CMS.
 */
export const CONSTRUCTION_CATEGORIES = [
  { slug: 'visokogradnja', label: 'Visokogradnja' },
  { slug: 'niskogradnja', label: 'Niskogradnja' },
  { slug: 'hidrogradnja', label: 'Hidrogradnja' },
] as const;

export type ConstructionType = (typeof CONSTRUCTION_CATEGORIES)[number]['slug'];
